import { AccountService } from './../../../core/services/account.service';
import { UtilizadorModel } from '@core/models';
import { StoreService } from '@core/services';
import { Component, HostListener, Input, OnInit } from '@angular/core';
import { Helpers } from '@core/helpers/helpers';

@Component({
  selector: 'app-cabecalho',
  templateUrl: './cabecalho.component.html',
  styleUrls: ['cabecalho.component.scss'],
})
export class CabecalhoComponent implements OnInit {
  
  utilizador: UtilizadorModel = null;
  isAuthenticated: boolean = false;

  @Input()
  showBusca: boolean = false;

  @Input()
  fixed: boolean = false;

  @Input()
  light: boolean = true;


  constructor(
    private helper: Helpers
  ) { }

  ngOnInit(): void {
    this.helper.isAuthenticationChanged().subscribe(r => {
      this.isAuthenticated = this.helper.isAuthenticated();
      if (this.helper.isAuthenticated()) this.utilizador = this.helper.getUserLogado();
    })
  }

  // evento para alterar o fundo da barra de navegação
  @HostListener('window:scroll', ['$event'])
  changeNavBarColor(event) {
    let pageYOffset = window.pageYOffset;
    let $navbar = document.querySelector('.nav-main');
    let $logo = document.getElementById("navbar-brand-logo");

    if (pageYOffset > 100) {
      $navbar.classList.remove('bg-transparent', 'navbar-dark');
      $navbar.classList.add('bg-white', 'navbar-light', 'shadow-sm');
      $logo.setAttribute('src', "/assets/images/logo-red.png");
    } else {
      $navbar.classList.add('bg-transparent', 'navbar-dark');
      $navbar.classList.remove('bg-white', 'navbar-light', 'shadow-sm');
      $logo.setAttribute('src', "/assets/images/logo-white.png");
    }
  }
}
